export const GET_VOUCHERS = "GET_VOUCHERS";
export const SET_VOUCHERS = "SET_VOUCHERS";
